import { parsePhoneNumberFromString } from 'libphonenumber-js';

const PHONE_LIKE = /^[+]?[\d\s\u00A0\u202F\u2007()\-\u2013\u2014\u2212.]+$/;

function looksLikePhoneNumber(query: string): boolean {
  const trimmed = query.trim();
  if (!trimmed || !PHONE_LIKE.test(trimmed)) {
    return false;
  }
  return trimmed.replace(/\D/g, '').length >= 3;
}

export function normalizeAlgoliaSearchQuery(query: string): string {
  const trimmed = query.trim();
  if (!looksLikePhoneNumber(trimmed)) {
    return query;
  }

  const parsed = parsePhoneNumberFromString(trimmed, 'US');
  if (parsed?.isValid()) {
    return parsed.number.replace(/\D/g, '');
  }

  return trimmed.replace(/\D/g, '');
}
